import { useEffect, useState } from "react";
import { Bell, BellRing } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { pushSupported, getPushSubscription, subscribeToPush, unsubscribeFromPush } from "@/lib/push";

export const PushBell = () => {
  const [state, setState] = useState<"off" | "on" | "unsupported" | "busy">("unsupported");

  useEffect(() => {
    if (!pushSupported()) return;
    getPushSubscription()
      .then((s) => setState(s ? "on" : "off"))
      .catch(() => setState("off"));
  }, []);

  if (state === "unsupported") return null;

  const toggle = async () => {
    const prev = state;
    setState("busy");
    try {
      if (prev === "on") {
        await unsubscribeFromPush();
        setState("off");
        toast("Breaking news alerts turned off");
      } else {
        const ok = await subscribeToPush();
        if (ok) {
          setState("on");
          toast.success("You'll be alerted the moment big news breaks");
        } else {
          setState("off");
          toast.error("Notifications are blocked in your browser settings");
        }
      }
    } catch {
      setState(prev === "busy" ? "off" : prev);
      toast.error("Could not update alerts — try again");
    }
  };

  return (
    <Button variant="ghost" size="icon" onClick={toggle} disabled={state === "busy"}
      aria-label={state === "on" ? "Disable push notifications" : "Enable push notifications"}
      data-testid="push-bell-button" title="Breaking news alerts"
      className={state === "on" ? "text-[#00E5FF] hover:text-[#00E5FF]" : "text-gray-400 hover:text-white"}>
      {state === "on" ? <BellRing className="h-4 w-4" /> : <Bell className="h-4 w-4" />}
    </Button>
  );
};
